import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";

import fallbackIcon from "../../assets/images/fallback_icon.png";
import "./sideNavbarItem.scss";
import { createRedirectURL } from "../../utils/helperFunctions";
import { isMobile } from "../../bridges/BridgeServices";

const SideNavbarItem = ({
  uri = "",
  allPagesData = {},
  activeChild = false,
}) => {
  const { title = "", thumbnailUrl = "" } =
    allPagesData[uri] || {};

  return (
    <Link to={createRedirectURL(uri)}>
      <div className="side-navbar-item">
        {thumbnailUrl ? (
          <div className="side-navbar-item-icon">
            {thumbnailUrl ? <img src={thumbnailUrl} /> : ""}
          </div>
        ) : (
          ""
        )}
        <div
          className={
            "side-navbar-item-title" +
            (activeChild ? " active-title" : "")
          }
        >
          {title}
        </div>
      </div>
    </Link>
  );
};

SideNavbarItem.propTypes = {
  uri: PropTypes.string,
  allPagesData: PropTypes.object,
  activeChild: PropTypes.bool,
};

export default SideNavbarItem;
